const state = {
  num: 1
}
const getters = {}
const actions = {}
const mutations = {
  incrementNum (state) {
    state.num++
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/demo/index.js